<template>
  <MainLayout>

  </MainLayout>
  <ImagePreviewModal/>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import ImagePreviewModal from "@/components/ui/ImagePreviewModal.vue";

export default {
  name: 'App',
  components: {
    MainLayout,
    ImagePreviewModal,
  },
}
</script>

<style lang="scss">
body {
  background-color: var(--cd-bg);
  color: var(--cd-text);
  font-family: var(--cd-default-font);
  font-optical-sizing: auto;
  font-weight: var(--cd-default-font-weight);
  font-style: normal;
  font-variation-settings:
      "wdth" 100,
      "YTLC" 500;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  margin: 0 auto;
}
#app {
  font-family: var(--cd-default-font);
}
a {
  color: var(--cd-link-color);
  text-decoration: none;
}
</style>
